module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABAElEQVQokZXTPy8EURQF8N8sCRJBNiIaS2ynVmp8AwU+AMkGlY5SqZEsjWj0olH4BlqFViP+FGSJSDZI7EoU8yYZI7M7TvPeOfee9+59f6JGsw0XmNMdV5jFN0SNZnsQTbziCGdJMINxnKOCh8Q8jLdU0g3qOMZ7Sq/gDpO4hxK+MjtM4yAkLHXqoYTPnFgZ8yn+JO53LBF6O60c0I+dFF/ENWpFzH3YymhV7BUxf2A5xTdxiv0i5lZIHsI6FvBMfGBFMYJdDCTCf8x/0K3sGdTCvBzGVtZ8Ir6Cnoy56vdDqeMxIVH4GDCFNaxiNGiH2MgrK93zLbYxgRVc4iXPCD/hGjRBvNy+xgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/index/exit.png
// module id = hGzq
// module chunks = 1